/* eslint-disable @typescript-eslint/no-unsafe-return */
interface ApiResponseType {
    ok: boolean;
    status: number;
    statusText: string;
    text: () => Promise<string>;
    json: () => Promise<Object>;
}

type Result = Promise<ApiResponseType>;

export function fetchCors(
    uri: string,
    options: { method?: "GET" | "POST"; body?: string; credentials?: string } = {}
): Result {
    const method = options.method || "GET";
    const xhr = createXHR();

    const promise = new Promise<ApiResponseType>((resolve, reject) => {
        xhr.onerror = reject;
        xhr.ontimeout = reject;
        xhr.withCredentials = options.credentials === "include";

        xhr.onload = () => {
            resolve({
                ok: xhr.status >= 200 && xhr.status < 300,
                status: xhr.status,
                statusText: xhr.statusText,
                text: () => Promise.resolve(xhr.responseText),
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                json: () => Promise.resolve(JSON.parse(xhr.responseText)),
            });
        };
    });

    xhr.open(method, uri);
    xhr.send(options.body);

    return promise;
}

function createXHR() {
    // @ts-ignore
    if (global.XDomainRequest) {
        // @ts-ignore
        return new XDomainRequest();
    }
    return new XMLHttpRequest();
}
